import React, { Component } from 'react';

class List extends Component {
    constructor(props) {
        super(props);
          this.state = {
              accepted:true,
              rejected:true
  
          }
      }

    accept=()=>{
        this.setState({accepted:false},()=>console.log())
    }

    reject=()=>{
        this.setState({rejected:false},()=>console.log())
    }

    render() {
        return (
            <div>
              <li className="listNav" key={this.props.index}>{this.props.list}   {this.state.accepted &&<i className="check fas fa-check" onClick={this.accept}/>} {this.state.rejected &&<i className="cross fas fa-times" onClick={this.reject}/>} </li>  
            </div>
        );
    }
}

export default List;